import * as React from 'react';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import { render, unmountComponentAtNode } from 'react-dom';
import lightTheme from '../../theme/light';

export enum LoaderMode {
  MODAL = 'modal',
  COVER = 'cover'
}

const getBackgroundForMode = (mode: LoaderMode): string => {
  switch (mode) {
    case LoaderMode.MODAL:
      return 'rgba(0, 0, 0, 0.5)';
    case LoaderMode.COVER:
      return 'white';
    default:
      return '';
  }
};

const LoaderContainer = styled.div<{ mode: LoaderMode }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ mode }) => getBackgroundForMode(mode)};
  .loader-wrapper {
    background-color: ${({ theme }) => theme.colors.white};
    padding: 50px;
    border-radius: 5px;
    user-select: none;
  }
`;

const containerId = 'loader';

export interface ILoaderProps {
  mode: LoaderMode;
  zIndex: number;
  children: React.ReactNode;
}
const Loader = (props: ILoaderProps) => {
  const { mode, zIndex, children } = props;
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <LoaderContainer
        mode={mode}
        style={{
          zIndex
        }}
      >
        <div className="loader-wrapper">{children}</div>
      </LoaderContainer>
    </ThemeProvider>
  );
};

const defaultLoaderOptions = {
  loaderContainerSelector: null,
  mode: LoaderMode.MODAL,
  zIndex: 9999
};
export const showLoader = (
  contentComponent,
  options: {
    loaderContainerSelector?: string;
    mode?: LoaderMode;
    zIndex?: number;
  } = defaultLoaderOptions
) => {
  const {
    loaderContainerSelector = defaultLoaderOptions.loaderContainerSelector,
    mode = defaultLoaderOptions.mode,
    zIndex = defaultLoaderOptions.zIndex
  } = options;

  if (document.querySelector(`#${containerId}`)) {
    return;
  }

  const containerNode = document.createElement('div');
  containerNode.setAttribute('id', containerId);
  const defaultWrapperNode = document.body;
  const wrapperNode =
    document.querySelector(loaderContainerSelector) || defaultWrapperNode;

  wrapperNode.appendChild(containerNode);

  render(
    // TODO find better way to pass theme
    <ThemeProvider theme={lightTheme}>
      <Loader mode={mode} zIndex={zIndex}>
        {contentComponent}
      </Loader>
    </ThemeProvider>,
    containerNode
  );
};

export const hideLoader = () => {
  const loaderNode = document.querySelector(`#${containerId}`);

  if (loaderNode) {
    unmountComponentAtNode(loaderNode);

    loaderNode.remove();
  }
};

export default Loader;
